import PodModal from './styled';

export default PodModal;
